import { Box, InputBase, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import DownArrow from "../assets/SVG/downArrow";

export default function ColorInput({ width, color, Color, setColor,onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [Color, setColor] = useState({color:'white',name:'سفید'});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClickColor = (e) => {
    if (onChange) {
      onChange(e);
      setColor(e);
    } else {
      setColor(e);
    }
    handleClose();
  };
  return (
    <>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: width + "20px" || "173px",
            // height: "40px",
            // padding: "10px ",
            borderRadius: "10px",
            mt: "5px",
            display: "flex",
            flexWrap: "wrap",
          },
          //   "& .MuiBackdrop-root": {
          //     backgroundColor: "#00000060",
          //   },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {color.map((elem) => (
          <Box
            onClick={() => handleClickColor(elem)}
            sx={{ cursor: "pointer" }}
            m="7px"
            width={"20px"}
            height="20px"
            bgcolor={elem.color}
            borderRadius="50%"
          ></Box>
        ))}
      </Popover>
      <Box mr="10px" width={"fit-content"}>
        <Typography
          sx={{
            color: "#000",
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "bold",
            lineHeight: "18px",
            mb: "5px",
          }}
        >
          {"انتخاب رنگ دلخواه"}
        </Typography>
        <Box
          sx={{ cursor: "pointer" }}
          onClick={handleClick}
          width={width || "145px"}
          className="inputForm"
        >
          <Box width={"100%"} display={"flex"} alignItems="center">
            <Box
              width="15px"
              height="15px"
              bgcolor={Color.color}
              borderRadius={"50%"}
            ></Box>
            <Typography
              sx={{ minInlineSize: "max-content" }}
              fontSize="13px"
              mr="10px"
              color={"#3A3939"}
            >
              {`پیش فرض ${Color.name}`}
            </Typography>
          </Box>
          <DownArrow transform={anchorEl ? true : false} />
        </Box>
      </Box>
    </>
  );
}
